import React from "react";
import Icon from "../../icons/Icon";
import iconsList from "../../icons/iconsList";
import classes from "./TreeSelectTrigger.module.css";

const TreeSelectTrigger = ({ open, chips, placeholder, onToggle }) => {
    
    const hasValue = chips && chips.length > 0;

    return (
        <button
            type="button"
            className={`${classes.Trigger} ${open ? classes.TriggerOpen : ""}`}
            onClick={onToggle}
        >
            <span className={classes.ChipArea}>
                {hasValue ? (
                    <span className={classes.ChipsList}>
                        {chips.map((chip, i) => (
                            <span key={i} className={classes.Chip}>
                                <span
                                    className={classes.ChipClear}
                                    onClick={(e) => { e.stopPropagation(); chip.onClear(e); }}
                                >
                                    <Icon name={iconsList.closeCircleFilled} color="#925fe2" size="16px" />
                                </span>
                                <span className={classes.ChipDot} />
                                <span className={classes.ChipLabel}>{chip.label}</span>
                            </span>
                        ))}
                    </span>
                ) : (
                    <span className={classes.Placeholder}>{placeholder}</span>
                )}
            </span>
            <span className={classes.TriggerCaret}>
                <Icon name={iconsList.caretDown} color="#925fe2" size="16px" />
            </span>
        </button>
    );
};

export default TreeSelectTrigger;
